module.exports = __webpack_public_path__ + "static/media/Cholesterol.065b3312.jpg";